var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivatedeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C9.35504 0 9.64286 0.287746 9.64286 0.642698V7.71237C9.64286 8.06732 9.35504 8.35507 9 8.35507C8.64496 8.35507 8.35714 8.06732 8.35714 7.71237V0.642698C8.35714 0.287746 8.64496 0 9 0ZM4.36386 2.02104C4.58235 2.30082 4.5326 2.7047 4.25275 2.92313C2.98659 3.9114 2.0606 5.27017 1.60397 6.80985C1.14734 8.34954 1.18285 9.99332 1.70556 11.5119C2.22826 13.0304 3.21208 14.3479 4.51974 15.2806C5.8274 16.2133 7.39367 16.7146 9 16.7146C10.6063 16.7146 12.1726 16.2133 13.4803 15.2806C14.7879 14.3479 15.7717 13.0304 16.2944 11.5119C16.8171 9.99332 16.8527 8.34953 16.396 6.80985C15.9394 5.27017 15.0134 3.9114 13.7473 2.92313C13.4674 2.7047 13.4177 2.30082 13.6361 2.02104C13.8546 1.74125 14.2586 1.69152 14.5385 1.90995C16.0156 3.06293 17.096 4.64816 17.6287 6.44446C18.1614 8.24075 18.12 10.1585 17.5102 11.9301C16.9004 13.7017 15.7526 15.2389 14.227 16.327C12.7014 17.4151 10.8741 18 9 18C7.12594 18 5.29863 17.4151 3.77303 16.327C2.24743 15.2389 1.09964 13.7017 0.489819 11.9301C-0.120003 10.1585 -0.161438 8.24075 0.371296 6.44446C0.90403 4.64816 1.98436 3.06293 3.46154 1.90995C3.74139 1.69152 4.14537 1.74125 4.36386 2.02104Z",
    fill: "#939AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivatedeactivate);
export default __webpack_public_path__ + "static/media/activate:deactivate.3c8ec5ff65b5ed44c1125706ac690f1d.svg";
export { ForwardRef as ReactComponent };